<template>
  <div class="locale-switcher">
    <select
      v-model="currentLocale"
      @change="changeLocale"
      class="form-select form-select-sm"
      aria-label="Language selector"
    >
      <option
        v-for="locale in availableLocales"
        :key="locale.code"
        :value="locale.code"
      >
        {{ locale.name }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import axiosClient from '../../utils/helpers/axios_client';

const { locale } = useI18n();

const currentLocale = ref(locale.value);

const availableLocales = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' }
];

const changeLocale = async () => {
  try {
    // Update Vue I18n locale
    locale.value = currentLocale.value;

    // Update Rails session/user preference via API
    await axiosClient.post('/set_locale', {
      locale: currentLocale.value
    });

    // Update HTML lang attribute
    document.documentElement.lang = currentLocale.value;

    // Reload page to apply Rails translations
    window.location.reload();
  } catch (error) {
    console.error('Failed to change locale:', error);
  }
};

onMounted(() => {
  // Initialize from HTML lang attribute
  const htmlLang = document.documentElement.lang;
  if (htmlLang && availableLocales.some(l => l.code === htmlLang)) {
    currentLocale.value = htmlLang;
    locale.value = htmlLang;
  }
});
</script>

<style scoped>
.locale-switcher {
  display: inline-block;
}

.locale-switcher select {
  cursor: pointer;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: inherit;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
}

.locale-switcher select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
}

.locale-switcher select option {
  background-color: #fff;
  color: #000;
}
</style>
